module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('section', {
    staticClass: "main_section",
    class: {
      'pic--1': true
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "menu-nav"
  }, [_c('v-btn', {
    class: {
      'active': _vm.page === 1
    },
    attrs: {
      "flat": "",
      "large": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.goPage(1)
      }
    }
  }, [_vm._v("活動介紹")]), _vm._v(" |\n    "), _c('v-btn', {
    class: {
      'active': _vm.page === 2
    },
    attrs: {
      "flat": "",
      "large": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.goPage(2)
      }
    }
  }, [_vm._v("活動獎項")]), _vm._v(" |\n    "), _c('v-btn', {
    class: {
      'active': _vm.page === 3
    },
    attrs: {
      "flat": "",
      "large": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.goPage(3)
      }
    }
  }, [_vm._v("使用說明")]), _vm._v(" |\n    "), _c('v-btn', {
    class: {
      'active': _vm.page === 4
    },
    attrs: {
      "flat": "",
      "large": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.goPage(4)
      }
    }
  }, [_vm._v("抽獎說明")]), _vm._v(" |\n    "), _c('v-btn', {
    class: {
      'active': _vm.page === 5
    },
    attrs: {
      "flat": "",
      "large": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.goPage(5)
      }
    }
  }, [_vm._v("注意事項")]), _vm._v(" |\n    "), _c('v-btn', {
    class: {
      'active': _vm.page === 6
    },
    attrs: {
      "flat": "",
      "large": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.goPage(6)
      }
    }
  }, [_vm._v("得獎公告")])], 1), _vm._v(" "), (_vm.page == 1) ? _c('section', {
    staticClass: "content"
  }, [_c('v-row', {
    staticClass: "text-xs-left"
  }, [_c('v-col', {
    attrs: {
      "md8": "",
      "offset-md2": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('strong', [_vm._v("活動期間")]), _c('p', [_vm._v("2018/7/20~2018/10/15")]), _vm._v(" "), _c('strong', [_vm._v("參加對象")]), _vm._v(" "), _c('ol', {
    staticClass: "ml-5"
  }, [_c('li', [_vm._v("一般民眾，註冊成為LiveABC官網會員後可使用。")]), _vm._v(" "), _c('li', [_vm._v("新北市小學/國中/高中學生，可透過新北市親師生平台帳號登入。")])]), _vm._v(" "), _c('strong', [_vm._v("活動方式")]), _vm._v(" "), _c('ol', {
    staticClass: "ml-5"
  }, [_c('li', [_vm._v("於活動期間內，登入遊新北學英語APP。")]), _vm._v(" "), _c('li', [_vm._v("完成每日任務、指定打卡、累積登入任一條件，即可獲得來福幣點數。")]), _vm._v(" "), _c('li', [_vm._v("使用來福幣點數兌換抽獎券，即有機會抽中活動獎項。")])]), _vm._v(" "), _c('strong', [_vm._v("立即下載")]), _vm._v(" "), _c('v-row', {
    staticClass: "text-xs-center"
  }, [_c('v-col', {
    attrs: {
      "sm4": "",
      "offset-sm2": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/events/summer2018/ntc4g-apple.png"),
      "width": "50%"
    }
  }), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://itunes.apple.com/tw/app/%E6%96%B0%E5%8C%97%E5%B8%82%E8%8B%B1%E8%AA%9E%E6%99%BA%E6%85%A7%E5%9F%8E/id1337959562?mt=8",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/icon_02.png")
    }
  })])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "sm4": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/events/summer2018/ntc4g-google.png"),
      "width": "50%"
    }
  }), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.liveabc.ntc4g",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/icon_03.png")
    }
  })])])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.page == 2) ? _c('section', {
    staticClass: "content"
  }, [_c('v-row', {
    staticClass: "text-xs-left"
  }, [_c('v-col', {
    attrs: {
      "md10": "",
      "offset-md1": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [(!_vm.authorized) ? _c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('td', [_vm._v("頭獎")]), _vm._v(" "), _c('td', [_vm._v("SONY DSC-WX500數位相機")]), _vm._v(" "), _c('td', [_vm._v("價值10,980元")]), _vm._v(" "), _c('td', [_vm._v("1名")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("貳獎")]), _vm._v(" "), _c('td', [_vm._v("Apple iPad 32G wifi")]), _vm._v(" "), _c('td', [_vm._v("價值10,900元")]), _vm._v(" "), _c('td', [_vm._v("1名")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("參獎")]), _vm._v(" "), _c('td', [_vm._v("ASUS ROG Strix Fusion 300 電競耳機")]), _vm._v(" "), _c('td', [_vm._v("價值3,590元")]), _vm._v(" "), _c('td', [_vm._v("1名")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("肆獎")]), _vm._v(" "), _c('td', [_vm._v("《圖解生活英語》點讀套書")]), _vm._v(" "), _c('td', [_vm._v("價值2,590元")]), _vm._v(" "), _c('td', [_vm._v("2套")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("伍獎")]), _vm._v(" "), _c('td', [_vm._v("《知識大圖解》雜誌12期")]), _vm._v(" "), _c('td', [_vm._v("價值1,990元")]), _vm._v(" "), _c('td', [_vm._v("5名")])])]) : _c('div', [_c('p', {
    staticClass: "text-xs-right"
  }, [_vm._v("來福幣：" + _vm._s(_vm.coin))]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, _vm._l((_vm.awards), function(award) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(award.prize))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(award.item))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "200px"
      }
    }, [_vm._v("持有 " + _vm._s(award.userTickectCount) + " 張抽獎卷")])])
  }))]), _vm._v(" "), (!_vm.authorized) ? _c('p', {
    staticClass: "text-xs-center mt-5"
  }, [_vm._v("\n          登入「遊新北學英語」APP，可查詢來福幣數量與抽獎券資訊。"), _c('br'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [_vm._v("登入")])], 1) : _vm._e()])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.page == 3) ? _c('section', {
    staticClass: "content"
  }, [_c('v-row', {
    staticClass: "text-xs-left"
  }, [_c('v-col', {
    attrs: {
      "md8": "",
      "offset-md2": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('strong', [_vm._v("獎勵內容")]), _vm._v(" "), _c('ol', {
    staticClass: "ml-5"
  }, [_c('li', [_vm._v("於活動期間內完成每日任務、指定打卡、累積登入任一條件，即可獲得任務獎勵。")]), _vm._v(" "), _c('li', [_vm._v("請於指定期限內領取任務獎勵－來福幣，一經過期，恕無法領取來福幣。")])]), _vm._v(" "), _c('strong', [_vm._v("獲得任務獎勵方法如下：")]), _vm._v(" "), _c('v-row', {
    staticClass: "img-text"
  }, [_c('v-col', {
    attrs: {
      "sm12": ""
    }
  }, [_vm._v("\n            I. 完成每日任務\n            "), _c('p', {
    staticClass: "text-xs-center pb-3"
  }, [_vm._v("1. 每日登入：每日登入遊新北學英語APP")])]), _vm._v(" "), _c('v-col', {
    staticClass: "text-xs-center",
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/events/summer2018/app_screen/section-1/1-1.jpg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("進入學習地圖，完成每日登入。")])]), _vm._v(" "), _c('v-col', {
    staticClass: "text-xs-center",
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/events/summer2018/app_screen/section-1/1-2.jpg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("於每日任務，點選 [領取]。")])]), _vm._v(" "), _c('v-col', {
    staticClass: "text-xs-center",
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/events/summer2018/app_screen/section-1/1-3.jpg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("點選 [確定] 完成領取。")])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('v-row', {
    staticClass: "img-text"
  }, [_c('v-col', {
    staticClass: "text-xs-center",
    attrs: {
      "sm12": ""
    }
  }, [_c('p', {
    staticClass: "text-xs-center pb-3"
  }, [_vm._v("2. 完成每日指定學習點簡介/會話/圖解課程測驗")])]), _vm._v(" "), _c('v-col', {
    staticClass: "text-xs-center",
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/events/summer2018/app_screen/section-2/2-1.jpg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("於每日任務，點選指定學習點項目，點選[前往]。")])]), _vm._v(" "), _c('v-col', {
    staticClass: "text-xs-center",
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/events/summer2018/app_screen/section-2/2-2.jpg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("參考指定學習點項目，點選地圖上的學習樹。")])]), _vm._v(" "), _c('v-col', {
    staticClass: "text-xs-center",
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/events/summer2018/app_screen/section-2/2-3.jpg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("點選指定的學習課程。")])]), _vm._v(" "), _c('v-col', {
    staticClass: "text-xs-center",
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/events/summer2018/app_screen/section-2/2-4.jpg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("看完簡介影片、會話影片或圖解單字課程，點選右下角的[工具]按鈕。")])]), _vm._v(" "), _c('v-col', {
    staticClass: "text-xs-center",
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/events/summer2018/app_screen/section-2/2-5.jpg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("完成課後練習，並答對所有題目。")])]), _vm._v(" "), _c('v-col', {
    staticClass: "text-xs-center",
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/events/summer2018/app_screen/section-2/2-6.jpg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("點選[繼續探索]，完成指定的學習項目。")])]), _vm._v(" "), _c('v-col', {
    staticClass: "text-xs-center",
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/events/summer2018/app_screen/section-2/2-7.jpg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("於每日任務，點選 [領取]。")])]), _vm._v(" "), _c('v-col', {
    staticClass: "text-xs-center",
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/events/summer2018/app_screen/section-2/2-8.jpg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("點選 [確定] 完成領取。")])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('v-row', {
    staticClass: "img-text"
  }, [_c('v-col', {
    attrs: {
      "sm12": ""
    }
  }, [_vm._v("\n            II. 完成指定打卡\n          ")]), _vm._v(" "), _c('v-col', {
    staticClass: "text-xs-center",
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/events/summer2018/app_screen/section-3/3-1.jpg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("參考指定打卡清單")])]), _vm._v(" "), _c('v-col', {
    staticClass: "text-xs-center",
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/events/summer2018/app_screen/section-3/3-2.jpg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("抵達現場，點選地圖上的指定學習樹。")])]), _vm._v(" "), _c('v-col', {
    staticClass: "text-xs-center",
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/events/summer2018/app_screen/section-3/3-3.jpg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("點選 [請打卡]。")])]), _vm._v(" "), _c('v-col', {
    staticClass: "text-xs-center",
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/events/summer2018/app_screen/section-3/3-4.jpg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("於現場找到提示圖片，系統將透過AR技術進行辨識。")])]), _vm._v(" "), _c('v-col', {
    staticClass: "text-xs-center",
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/events/summer2018/app_screen/section-3/3-5.jpg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("完成學習點打卡，點選 [X] 離開。")])]), _vm._v(" "), _c('v-col', {
    staticClass: "text-xs-center",
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/events/summer2018/app_screen/section-3/3-6.jpg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("於每日任務，點選 [領取]。")])]), _vm._v(" "), _c('v-col', {
    staticClass: "text-xs-center",
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/events/summer2018/app_screen/section-3/3-7.jpg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("點選 [確定] 完成領取。")])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "sm12": ""
    }
  }, [_vm._v("\n            III. 完成累積登入"), _c('br'), _vm._v("\n            活動期間，累積登入5/10/20/40/50天，即可獲得任務獎勵。\n          ")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.page == 4) ? _c('section', {
    staticClass: "content"
  }, [_c('v-row', {
    staticClass: "text-xs-left"
  }, [_c('v-col', {
    attrs: {
      "md8": "",
      "offset-md2": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('strong', [_vm._v("抽獎說明")]), _vm._v(" "), _c('ol', {
    staticClass: "ml-5"
  }, [_c('li', [_vm._v("於活動期間內使用來福幣兌換抽獎券，即可參加抽獎贏得大獎。")]), _vm._v(" "), _c('li', [_vm._v("每參與一次抽獎，兌換當下即需扣除10~100點來福幣點數，一旦參與抽獎，即無法取消參與紀錄亦無法退還點數。")]), _vm._v(" "), _c('li', [_vm._v("使用來福幣兌換抽獎券，請詳細閱讀完活動連結內完整注意事項，並於當下完成扣點，成功扣點者始符合本活動抽獎資格，並獲得1次抽獎資格，抽獎不保證中獎。每人每日不限參加次數，每人僅限中獎一次，請確認您的來福幣點數是否充足；來福幣剩餘點數不足，無法成功完成扣點者，視同放棄本活動抽獎資格，恕不另行通知。")]), _vm._v(" "), _c('li', [_vm._v("2018/10/19由系統隨機抽出幸運得獎者，2018/10/25前公告中獎名單於官方網站。")])]), _vm._v(" "), _c('v-row', {
    staticClass: "img-text mt-5"
  }, [_c('v-col', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/events/summer2018/app_screen/section-5/5-1.jpg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("開啟遊新北學英語 APP，點選活動圖示。")])]), _vm._v(" "), _c('v-col', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/events/summer2018/app_screen/section-5/5-2.jpg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("點選 [來福幣抽獎]，確認兌換項目並詳閱注意事項，點選 [點數] 按鈕進行兌換。")])]), _vm._v(" "), _c('v-col', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/events/summer2018/app_screen/section-5/5-3.jpg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("瀏覽活動條件，並勾選「我已觀看並同意活動條款」，點選 [同意活動條款]。")])]), _vm._v(" "), _c('v-col', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/events/summer2018/app_screen/section-5/5-4.jpg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("再次確認兌換資訊，點選 [兌換] 按鈕]。")])]), _vm._v(" "), _c('v-col', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/events/summer2018/app_screen/section-5/5-5.jpg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("成功獲得抽獎資格1次。")])])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.page == 5) ? _c('section', {
    staticClass: "content"
  }, [_c('v-row', {
    staticClass: "text-xs-left"
  }, [_c('v-col', {
    attrs: {
      "md8": "",
      "offset-md2": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('strong', [_vm._v("一、活動贈獎辦法：")]), _vm._v(" "), _c('ol', {
    staticClass: "ml-5 mb-5"
  }, [_c('li', [_vm._v("參加者於參加本活動之同時，即同意接受本活動之活動辦法與注意事項之規範，如有違反活動相關規範，即自動喪失本活動參加資格，如為得獎者，則喪失得獎資格。")]), _vm._v(" "), _c('li', [_vm._v("獎項及領獎程序\n            "), _c('div', {
    staticClass: "pl-5"
  }, [_c('ol', {
    attrs: {
      "type": "a"
    }
  }, [_c('li', [_vm._v("得獎通知：凡活動得獎者，希伯崙股份有限公司（以下簡稱本公司）將於"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("2018年10月25日前")]), _vm._v("公布於"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("「新北市英語智慧城」官方網站及Facebook粉絲團，並寄發中獎通知email")]), _vm._v("，請活動參加者注意網站公告及電子信箱。")]), _vm._v(" "), _c('li', [_vm._v("準中獎人若經檢查發現資格或身分不符或資料為偽造變造者，本公司將取消得獎者資格；準中獎人若未依規定於領獎資格確認期間內（以郵戳為憑）自行列印及填妥中獎通知書後寄回希伯崙股份有限公司，或因個人資料填寫錯誤導致無法聯絡者，或領獎時未能出具上述資料者，皆視同放棄得獎權益。中獎者若因會員資料（姓名、電話、地址）不全或有誤，導致活動小組無法連絡通知者，本公司有權予以取消中獎者之權利。")]), _vm._v(" "), _c('li', [_vm._v("中獎者未提供或提供不實個人基本資料，視同放棄得獎權利並自負其責。若未於指定時間內完成兌獎程序，即視同放棄獎項，恕不補發獎項。")])])])]), _c('li', [_vm._v("本公司保留修改及終止本活動與獎項細節之權利，無須事前通知，並有權對本活動所有事宜作出解釋或裁決。")]), _vm._v(" "), _c('li', [_vm._v("本公司有權檢視各活動參加者之活動參與行為及中獎情形是否涉嫌以任何其他不正當的方式意圖以進行不實或虛偽活動參與行為，活動參加者因上述情形所獲得之活動資格及獎額，本公司保有取消得獎資格的權利，並保留法律追訴權。")]), _vm._v(" "), _c('li', [_vm._v("參加活動者若以惡意程式、竄改紀錄或違反法律或其他非法之方式違反本活動之公平性或正確性，或意圖混淆、影響本活動結果者，經本公司發現或經第三人檢舉，本公司除得取消其中獎資格外，並得追回獎項。參加活動者應自行承擔因違反相關規定所生之一切法律責任。")]), _vm._v(" "), _c('li', [_vm._v("贈品不得轉換現金，獎項以實體為主。")]), _vm._v(" "), _c('li', [_vm._v("參加活動者即表示同意並遵守本公司的活動公告，如有違反，即喪失參加活動資格。")]), _vm._v(" "), _c('li', [_vm._v("中獎人若未滿20歲，且依法規定需提戶口名簿備查。")]), _vm._v(" "), _c('li', [_vm._v("如因不可抗拒之事由導致獎品內容變更，中獎人同意接受本公司所安排之等值替代獎品，中獎者不得要求折現或轉換其他商品，亦不得轉讓獎品給他人。")]), _vm._v(" "), _c('li', [_vm._v("本活動所有抽獎與兌換贈品，僅限郵寄至臺、澎、金、馬地區，但因商品特性或材質無法郵寄者，不在此限。")]), _vm._v(" "), _c('li', [_vm._v("依中華民國稅法規定，贈品價值超過新台幣1,000元，須計入個人所得稅計算。")]), _vm._v(" "), _c('li', [_vm._v("主辦單位：希伯崙股份有限公司。")]), _vm._v(" "), _c('li', [_vm._v("得獎者務必保留郵寄憑證，避免影響兌獎權益。")])]), _vm._v(" "), _c('strong', [_vm._v("二、參加者個人資料使用條款：")]), _vm._v(" "), _c('ol', {
    staticClass: "ml-5"
  }, [_c('li', [_vm._v("參加者同意希伯崙股份有限公司，依照個人資料保護法之規定，基於「新北市英語智慧城」網站抽獎活動（下稱本活動）之執行、蒐集、處理並利用參加者所提供之個人資料（含姓名、電子郵件信箱、電話、地址），截至參加者主動請求本公司刪除、停止處理或利用其個人資料為止。")]), _vm._v(" "), _c('li', [_vm._v("參加者所提供的個人資料，將用於提供本公司寄送確認信件、確認身份等與本活動有關之事宜使用。參加者有權得隨時請求本公司查閱、給予複本、或補正本人的個人資料，亦得隨時洽本公司表示拒絕本公司繼續蒐集、處理、利用或刪除本人的個人資料；惟本公司因執行本活動所必要者，則不在此限。若參加者不提供提供錯誤之個人資料，本公司將取消參加者之參加或得獎資格。")]), _vm._v(" "), _c('li', [_vm._v("當您參加此抽獎活動即成為本公司會員並永久享有會員權益，並同意下列條款：為提供更好服務，希伯崙股份有限公司或關係企業或合作對象，於業務推展之必要範圍內及業務推廣期間及地域內，得使用本人所提供之個人資料（包括個人姓名、出生年月日、教育、職業、地址、email、聯絡方式等），並得以（包括但不限於）發送廣告、活動訊息、電話行銷等通知您相關訊息。除本人有反對表示，希伯崙股份有限公司得於本刊發行期間及地區內（與會員有效期間同），利用本人所提供之個人資料。希伯崙股份有限公司對所蒐集之資料依法有保密義務。本人有隨時求停止蒐集、處理、利用或請求刪除之權利。")]), _vm._v(" "), _c('li', [_vm._v("有關本活動個人資料保護之事項，如需聯絡請洽："), _c('a', {
    attrs: {
      "href": "mailto:service@liveabc.com"
    }
  }, [_vm._v("service@liveabc.com")])])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.page == 6) ? _c('section', {
    staticClass: "content"
  }, [_c('v-row', {
    staticClass: "text-xs-left"
  }, [_c('v-col', {
    attrs: {
      "md8": "",
      "offset-md2": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('p', {
    staticClass: "text-xs-center"
  }, [_c('video', {
    attrs: {
      "src": "/ntc/static/20181023.mp4",
      "width": "80%",
      "controls": ""
    }
  })]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("2018/10/19由系統隨機抽出幸運得獎者，2018/10/25前公告中獎名單於官方網站。")])]), _vm._v(" "), _c('strong', [_vm._v("中獎說明：")]), _vm._v(" "), _c('ol', {
    staticClass: "ml-5"
  }, [_c('li', [_vm._v("參加活動者務必填寫正確E-mail信箱，並同步密切注意中獎名單。")]), _vm._v(" "), _c('li', [_vm._v("得獎者請於2018/10/30前與主辦單位聯繫回覆，以免錯過得獎權利。")]), _vm._v(" "), _c('li', [_vm._v("活動所取得之個人資料僅限抽獎活動使用，不做其他用途。")])]), _vm._v(" "), _c('strong', [_vm._v("獎項寄送：")]), _vm._v(" "), _c('p', [_vm._v("各獎項將於確認各得獎者身份後2週後陸續寄送。")])])], 1)], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fecf28e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/events/2018Summer.vue
// module id = 781
// module chunks = 1